import { render, staticRenderFns } from "./transferLogOut.vue?vue&type=template&id=32786d9f&scoped=true"
import script from "./transferLogOut.vue?vue&type=script&lang=js"
export * from "./transferLogOut.vue?vue&type=script&lang=js"
import style0 from "./transferLogOut.vue?vue&type=style&index=0&id=32786d9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32786d9f",
  null
  
)

export default component.exports